import pick from 'lodash/pick';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { savePayout } from '../../util/api';
// import { getSupportedBanks, savePayout } from '../../util/api';

const STATIC_BANKS = [
  { code: 'bca', name: 'PT. BANK CENTRAL ASIA TBK.' },
  { code: 'danamon', name: 'PT. BANK DANAMON INDONESIA TBK.' },
  { code: 'bukopin', name: 'PT BANK KB BUKOPIN TBK.' },
  { code: 'mandiri', name: 'PT. BANK MANDIRI (PERSERO) TBK.' },
  { code: 'mega_tbk', name: 'PT. BANK MEGA TBK.' },
  { code: 'bni', name: 'PT. BANK NEGARA INDONESIA (PERSERO)' },
  { code: 'bri', name: 'PT. BANK RAKYAT INDONESIA (PERSERO)' },
  { code: 'bsi', name: 'PT. BANK SYARIAH INDONESIA, TBK.' },
  { code: 'btn', name: 'PT. BANK TABUNGAN NEGARA (PERSERO)' },
  { code: 'cimb', name: 'PT. BANK CIMB NIAGA TBK.' },
  { code: 'maybank', name: 'PT. BANK MAYBANK INDONESIA TBK.' },
  { code: 'ocbc', name: 'PT. BANK OCBC NISP TBK.' },
  { code: 'panin', name: 'PT. PANIN BANK TBK.' },
  { code: 'permata', name: 'PT. BANK PERMATA TBK.' },
  { code: 'allo', name: 'PT. ALLO BANK INDONESIA TBK.' },
  { code: 'jago', name: 'PT. BANK JAGO TBK.' },
  { code: 'mayapada', name: 'PT. BANK MAYAPADA INTERNASIONAL, TBK' },
  { code: 'china', name: 'KC BANK OF CHINA LIMITED' },
  { code: 'agroniaga', name: 'PT. BANK RAKYAT INDONESIA AGRONIAGA TBK.' },
  { code: 'sinarmas', name: 'PT. BANK SINARMAS' },
  { code: 'btpn', name: 'PT. BANK TABUNGAN PENSIUNAN NASIONAL' },
  { code: 'citibank', name: 'CITIBANK' },
  { code: 'dbs', name: 'PT. BANK DBS INDONESIA' },
  { code: 'hsbc', name: 'PT. BANK HSBC INDONESIA' },
  { code: 'icbc', name: 'PT. BANK ICBC INDONESIA' },
  { code: 'mitsubishi', name: 'THE BANK OF TOKYO MITSUBISHI UFJ LTD.' },
  { code: 'stanchard', name: 'STANDARD CHARTERED BANK' },
  { code: 'uob', name: 'PT. BANK UOB INDONESIA' },
];

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/MidtransPayoutPage/SET_INITIAL_VALUES';
export const CLEAR_ERROR = 'app/MidtransPayoutPage/CLEAR_ERROR';

export const SAVE_PAYOUT_DETAILS_REQUEST = 'app/MidtransPayoutPage/SAVE_PAYOUT_DETAILS_REQUEST';
export const SAVE_PAYOUT_DETAILS_SUCCESS = 'app/MidtransPayoutPage/SAVE_PAYOUT_DETAILS_SUCCESS';
export const SAVE_PAYOUT_DETAILS_ERROR = 'app/MidtransPayoutPage/SAVE_PAYOUT_DETAILS_ERROR';

export const LOAD_BANKS_REQUEST = 'app/MidtransPayoutPage/LOAD_BANKS_REQUEST';
export const LOAD_BANKS_SUCCESS = 'app/MidtransPayoutPage/LOAD_BANKS_SUCCESS';
export const LOAD_BANKS_ERROR = 'app/MidtransPayoutPage/LOAD_BANKS_ERROR';

// ================ Reducer ================ //

const initialState = {
  payoutDetails: null,
  payoutDetailsSaved: false,
  payoutDetailsSaveInProgress: false,
  payoutDetailsSaveError: null,
  banks: [],
  loadBanksInProgress: false,
  loadBanksError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case CLEAR_ERROR:
      return { ...initialState };

    case SAVE_PAYOUT_DETAILS_REQUEST:
      return { ...state, payoutDetailsSaveInProgress: true, payoutDetailsSaveError: null };
    case SAVE_PAYOUT_DETAILS_ERROR:
      return { ...state, payoutDetailsSaveInProgress: false, payoutDetailsSaveError: payload };
    case SAVE_PAYOUT_DETAILS_SUCCESS:
      return {
        ...state,
        payoutDetailsSaveInProgress: false,
        payoutDetailsSaved: true,
        payoutDetails: payload,
      };

    case LOAD_BANKS_REQUEST:
      return { ...state, loadBanksInProgress: true, loadBanksError: null };
    case LOAD_BANKS_ERROR:
      return { ...state, loadBanksInProgress: false, loadBanksError: payload };
    case LOAD_BANKS_SUCCESS:
      return { ...state, loadBanksInProgress: false, banks: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const savePayoutDetailsRequest = () => ({
  type: SAVE_PAYOUT_DETAILS_REQUEST,
});
export const savePayoutDetailsError = payload => ({
  type: SAVE_PAYOUT_DETAILS_ERROR,
  payload,
});
export const savePayoutDetailsSuccess = payload => ({
  type: SAVE_PAYOUT_DETAILS_SUCCESS,
  payload,
});

export const loadBanksRequest = () => ({
  type: LOAD_BANKS_REQUEST,
});
export const loadBanksError = payload => ({
  type: LOAD_BANKS_ERROR,
  payload: payload,
});
export const loadBanksSuccess = payload => ({
  type: LOAD_BANKS_SUCCESS,
  payload: payload,
});

// ================ Thunks ================ //

export const savePayoutDetails = (values, isUpdateCall) => (dispatch, getState, sdk) => {
  const currentUser = getState().user.currentUser;
  dispatch(savePayoutDetailsRequest());

  return savePayout({ ...values, userId: currentUser.id.uuid })
    .then(response => {
      dispatch(savePayoutDetailsSuccess(response));
      return response;
    })
    .catch(e => {
      const errorMessage = e?.message;
      dispatch(savePayoutDetailsError(errorMessage));
    });
};

export const loadBanks = () => dispatch => {
  dispatch(loadBanksSuccess(STATIC_BANKS));
};

// export const loadBanks = () => (dispatch, getState, sdk) => {
//   dispatch(loadBanksRequest());
//   return getSupportedBanks({})
//     .then(response => {
//       const data = response.data.data;
//       const banks = data?.banks?.beneficiary_banks || [];
//       if (!!banks) {
//         dispatch(loadBanksSuccess(banks));
//       } else {
//         console.error('Failed to load banks', data);
//       }
//       return response;
//     })
//     .catch(error => {
//       console.error('Error fetching bank list', error);
//       dispatch(loadBanksError(error));
//     });
// };

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(setInitialValues());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(response => {
    const currentUser = getState().user.currentUser;
    if (currentUser) {
      dispatch(loadBanks());
    }
    return response;
  });
};
